module.exports = __webpack_public_path__ + "img/21-min.45ab1b96.jpg";